export default "__VITE_ASSET__C3bW634E__"